module.exports = __webpack_public_path__ + "media/images/landing/epl/regular-0c80b7dbf50d8c282688064c325ad235.png";